"use client";

import {
  useSubscriptionCheck as _useSubscriptionCheck,
  type SubscriptionCheckData,
} from "@repo/stripe/subscription-gate";
import { fetchSubscriptionStatus } from "./fetch-subscription-status";

/** Pre-configured subscription check with kinsa's fetcher. */
export function useSubscriptionCheck() {
  return _useSubscriptionCheck(fetchSubscriptionStatus);
}

/**
 * Subscription check seeded with the server-resolved status. The seed is a
 * required argument so a caller can't silently drop it.
 */
export function useSeededSubscriptionCheck(
  seed: SubscriptionCheckData | undefined
) {
  return _useSubscriptionCheck(fetchSubscriptionStatus, seed);
}
